import React from "react"
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

class SelectGroups extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      account: props.account,
      groupable_type: props.groupable_type,
      groups: props.groups,
      default_options: props.default_options,
      element_id: props.element_id,
      multiple: props.multiple,
      isLoading: true,
    };
  }

  componentDidMount() {
  }

  renderSelectGroups() {
    let debounceTimer;
    const account = this.state.account;
    const groupable_type = this.state.groupable_type;
    const groups = this.state.groups;
    const default_options = this.state.default_options;
    const multiple = this.state.multiple;

    const handleInputChange = value => {
    };

    const handleChange = value => {
      this.setState({
        groups: value
      });
      if (multiple) {
        let result = value.map((group) => group.id);
        document.getElementById(this.state.element_id).value = JSON.stringify(result);
      } else {
        document.getElementById(this.state.element_id).value = value ? value.id : null;
      }
    };

    const loadOptions = (value) => {
      return fetch(`/accounts/${account.id}/groups/select?search=${value}&groupable_type=${groupable_type}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }
      )
      .then(response => response.json());
    };

    const customOption = (group) => {
      return (
        <div>
          <div className="d-flex align-items-center">
            <div className="mr-1">
              {group["title"]}
            </div>
            {group["badge"] && <div className="ml-auto small">
              {group["badge"]}
            </div>}
          </div>
          {group["description"] && <div className="small select-description">
            {group["description"]}
          </div>}
        </div>
      );
    }

    const promiseOptions = (value) =>
      new Promise((resolve) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          resolve(loadOptions(value));
        }, 1000);
      });

    const handleFocus = () => {
      if (!groups && (!default_options || default_options.length === 0)) {
        loadOptions("").then((options) => {
          this.setState({ default_options: options });
        });
      }
    };

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={default_options}
        isMulti={multiple}
        placeholder={this.props.placeholder || "Select groups..."}
        value={groups}
        getOptionLabel={c => customOption(c)}
        getOptionValue={c => c.id}
        loadOptions={promiseOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onFocus={handleFocus}
        isClearable
        styles={{
          singleValue: (base) => ({ ...base, width: '96%' }),
          valueContainer: (base) => ({ ...base, minHeight: '40px'}),
        }}
      />
    );
  }

  render () {
    return (
      <div>
        {this.renderSelectGroups()}
      </div>
    );
  }
}

SelectGroups.propTypes = {
  account: PropTypes.object,
  groupable_type: PropTypes.string,
  groups: PropTypes.array,
  default_options: PropTypes.array,
  element_id: PropTypes.string,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default SelectGroups;
